import CurrencyPlugin from '@fiverr-private/currencies_plugin';

export type CurrencyType = ReturnType<CurrencyPlugin['getCurrency']>;

export const DEFAULT_CURRENCY = {
    forceRound: false,
    forceRoundFromAmount: 1000,
    name: 'USD',
    rate: 1,
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
    symbol: '$',
} satisfies CurrencyType;
